import type { NotebookNote } from '../../shared/types/notebook'

/** Get root-level notes (parentId === null), sorted by sortOrder */
export function getRootNotes(notes: NotebookNote[]): NotebookNote[] {
  return notes
    .filter(n => n.parentId === null)
    .sort((a, b) => a.sortOrder - b.sortOrder)
}

/** Get direct children of a given parent, sorted by sortOrder */
export function getChildren(notes: NotebookNote[], parentId: string): NotebookNote[] {
  return notes
    .filter(n => n.parentId === parentId)
    .sort((a, b) => a.sortOrder - b.sortOrder)
}

/** Get all pinned notes across the entire tree */
export function getPinnedNotes(notes: NotebookNote[]): NotebookNote[] {
  return notes.filter(n => n.pinned).sort((a, b) => a.sortOrder - b.sortOrder)
}

/** Check if a note has children */
export function hasChildren(notes: NotebookNote[], noteId: string): boolean {
  return notes.some(n => n.parentId === noteId)
}

/** Find a note by ID */
export function findNote(notes: NotebookNote[], noteId: string): NotebookNote | undefined {
  return notes.find(n => n.id === noteId)
}

// Mockup: client-side substring search. Production: hybrid pgvector cosine
// similarity (70%) + Postgres FTS (30%) via recall_notebook_hybrid() SQL
// function. See PGVECTOR_MIGRATION.md.
/** Flat search across all notes by title, content, and tags */
export function searchNotes(notes: NotebookNote[], query: string): NotebookNote[] {
  const q = query.toLowerCase()
  return notes.filter(n =>
    n.title.toLowerCase().includes(q) ||
    n.contentMd.toLowerCase().includes(q) ||
    n.tags.some(t => t.toLowerCase().includes(q))
  )
}
